import React from 'react';
import { PiEnvelopeSimple } from 'react-icons/pi';
import ContactForm from '../components/ContactForm';
import { COMPANY } from '../config/company';

const ContactPage = () => (
  <section className="bg-[#f7f5fd] px-6 py-14 text-ink md:px-12 md:py-20 lg:px-16">
    <div className="mx-auto grid max-w-[78rem] items-start gap-10 lg:grid-cols-[0.72fr_1.28fr] lg:gap-20">
      <div className="lg:sticky lg:top-32">
        <p className="text-sm font-bold uppercase tracking-[0.16em] text-violet-dark">Start a conversation</p>
        <div className="mt-4 h-1 w-16 bg-violet" />
        <h1 className="mt-8 text-5xl font-semibold leading-[0.95] tracking-[-0.055em] md:text-6xl">How can we<br />help?</h1>
        <p className="mt-6 max-w-md text-base leading-7 text-ink/65">
          Tell us what you need and we’ll make sure your message reaches the right place.
        </p>
        <div className="mt-9 border-t border-ink/10 pt-7">
          <p className="text-sm text-ink/55">Prefer email?</p>
          <a href={`mailto:${COMPANY.supportEmail}`} className="mt-2 inline-flex items-center gap-2 font-semibold text-violet-dark transition-colors hover:text-magenta">
            <PiEnvelopeSimple aria-hidden="true" /> {COMPANY.supportEmail}
          </a>
        </div>
      </div>

      <div className="rounded-[1.5rem] bg-white p-6 shadow-[0_18px_60px_rgba(4,11,65,.07)] sm:p-10 lg:p-12">
        <ContactForm />
      </div>
    </div>
  </section>
);

export default ContactPage;
